import { Component, HostListener, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService, ServiceRequestService } from 'src/app/services';
import { WorkshopJobcardCreateService } from '../../workshop-jobcard-create.service';

@Component({
  selector: 'app-workshop-jobcard-custom-question-details',
  templateUrl: './workshop-jobcard-custom-question-details.component.html',
  styleUrls: ['./workshop-jobcard-custom-question-details.component.scss']
})
export class WorkshopJobcardCustomQuestionDetailsComponent {

  @Input() jobcard: any;

  public updating: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private helpersService: HelpersService,
    private workshopJobcardCreateService: WorkshopJobcardCreateService,
    private serviceRequest: ServiceRequestService
  ) { }

  ngOnInit() {
    this.jobcard.customQuestions?.forEach(group =>
      group.customQuestions?.forEach(q => {
        if (q.controlType === 'CHECKBOX') {
          q.response = q.response === true || q.response === 'true';
        }
      })
    );
  }

  isvalid() {
    return this.workshopJobcardCreateService.isCustomQuestionsCompleted(this.jobcard);
  }

  done() {
    if (this.isvalid()) {
      this.activeModal.close(this.jobcard);
    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    if (this.jobcard.id) {
      this.save();
    } else {
      this.done();
    }
  }

  save() {
    if (this.isvalid()) {

      const data = this.jobcard.customQuestions.map((cq: any) => {
        return {
          serviceID: cq.serviceID,
          serviceTypeID: cq.serviceTypeID,
          groupName: cq.groupName,
          serviceType: cq.serviceType,
          customQuestionsResponses: cq.customQuestions.map((cqr: any) => {
            return {
              questionResponseID: cqr.id,
              response: cqr.response,
              controlType: cqr.controlType,
              question: cqr.question
            }
          })
        }
      });

      this.updating = true;
      this.serviceRequest.updateServiceCustomQuestionResponses(this.jobcard.partnerID, this.jobcard.id, data).subscribe({
        next: (response: any) => {
          this.activeModal.close(this.jobcard);
          this.updating = false;
        }, error: (error: any) => {
          this.updating = false;
        }
      });
    }
  }
}



/*
[
    {
        "serviceID": 499054,
        "groupName": "Suspension Services",
        "serviceTypeID": 1846,
        "serviceType": "Rear suspension",
        "customQuestionsResponses": [
            {
                "questionResponseID": 347,
                "question": "Rider weight (with gear - Kg)",
                "controlType": "TEXTINPUT",
                "response": "65kg"
            },
            {
                "questionResponseID": 348,
                "question": "Riding style (e.g. cross-country, trail, enduro, downhill)",
                "controlType": "TEXTAREA",
                "response": "Fast"
            },
            {
                "questionResponseID": 349,
                "question": "Prefer a firmer setup for climbing",
                "controlType": "CHECKBOX",
                "response": "true"
            }
        ]
    }
]
*/